import React from 'react'

import * as HoverCard from '@radix-ui/react-hover-card'

import CheckIcon from '../../vectors/CheckIcon'
import CallOut from '../Callout'

export const ReturnedCallOut: React.FC = () => {
  return (
    <HoverCard.Root openDelay={200} closeDelay={0}>
      <HoverCard.Trigger asChild>
        <a>
          <CallOut
            classes={{
              root: 'bg-green-light-fade cursor-pointer',
            }}
            icon={<CheckIcon />}
          >
            Returned
          </CallOut>
        </a>
      </HoverCard.Trigger>
      <HoverCard.Portal>
        <HoverCard.Content
          side="top"
          align="end"
          className="font-body shadow-elevation-2 rounded-sm bg-indigo-50 p-2 text-xs text-white"
        >
          You have successfully returned these shipments.
          <HoverCard.Arrow className="fill-indigo-50" />
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  )
}

export default ReturnedCallOut
